/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface DeleteContactFromOffer$Params {
  id: number;
  contactId: number;
}

export function deleteContactFromOffer(http: HttpClient, rootUrl: string, params: DeleteContactFromOffer$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, deleteContactFromOffer.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('contactId', params.contactId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

deleteContactFromOffer.PATH = '/offers/{id}/contacts/{contactId}';
